import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    title: _ctx.t('UPDATE_ASSET_CLASSIFICATION', { asset: _ctx.leadTypeLabel.toLowerCase() }),
    onConfirm: _ctx.validateAndSubmit,
    onCancel: _ctx.cancel,
    loading: _ctx.loading,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "q-pa-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            greedy: "",
            id: "asset-edition-form",
            ref: "assetEditionForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, _mergeProps(_ctx.INPUT_LG, {
                label: _ctx.t('NAME'),
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
              }), null, 16, ["label", "modelValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.technologyTypes,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.technologyTypes) = $event)),
                label: _ctx.t('TECHNOLOGY_TYPE'),
                options: _ctx.technologyTypesOptions
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                "allow-create": _ctx.canCreateTechnologyType && _ctx.isAllowedTechnologyType,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterTechnologyTypesOptions,
                "selected-item-slot": "",
                onCreateValue: _ctx.createTechnologyType
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "allow-create", "placeholder-value", "onFilter", "onCreateValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.stage,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stage) = $event))
              }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                label: _ctx.t('STAGE'),
                "allow-create": _ctx.canCreateStage && _ctx.isAllowedStage,
                options: _ctx.stageOptions,
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_SINGLE'),
                "option-label": "label",
                "option-value": "dobjId",
                removable: "",
                "selected-item-slot": "",
                onFilter: _ctx.filterStageOptions,
                onCreateValue: _ctx.createStage
              }), {
                "selected-item": _withCtx((scope) => [
                  _createVNode(_component_q_item_label, { class: "ellipsis" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.opt.label) + " ", 1),
                      _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.opt.label), 1)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 16, ["modelValue", "label", "allow-create", "options", "placeholder-value", "onFilter", "onCreateValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.indications,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.indications) = $event)),
                label: _ctx.t('INDICATION'),
                options: _ctx.indicationsOptions
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                "allow-create": _ctx.canCreateIndication && _ctx.isAllowedIndication,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterIndicationsOptions,
                "selected-item-slot": "",
                onCreateValue: _ctx.createIndication
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "allow-create", "placeholder-value", "onFilter", "onCreateValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.applications,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.applications) = $event))
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                label: _ctx.t('TECHNOLOGY_APPLICATION'),
                options: _ctx.applicationsOptions,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterApplicationsOptions,
                "selected-item-slot": "",
                "allow-create": _ctx.canCreateApplication && _ctx.isAllowedApplication,
                onCreateValue: _ctx.createApplication
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "placeholder-value", "onFilter", "allow-create", "onCreateValue"]),
              _createVNode(_component_q_input, _mergeProps({
                label: _ctx.t('DESCRIPTION'),
                placeholder: _ctx.t('PLACEHOLDER.DESCRIPTION'),
                "input-class": "'text-body1 text-primary-darker'"
              }, _ctx.TEXTAREA_LG, {
                modelValue: _ctx.description,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.description) = $event))
              }), null, 16, ["label", "placeholder", "modelValue"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "onConfirm", "onCancel", "loading"]))
}